var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemonstration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "28px",
    viewBox: "0 0 31 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uF685") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WORKSPACE-LIBRARY",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workspace-lib-3",
    transform: "translate(-35.000000, -406.000000)",
    fill: "#262262",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.65355,433.127646 L55.8463534,431.934842 C56.1759425,431.605253 56.1759425,431.07101 55.8463534,430.741421 L51.8749598,426.770027 L51.8749598,424.937512 L61.9999356,424.937512 C62.9317457,424.937512 63.6874316,424.181826 63.6874316,423.250016 L63.6874316,409.750048 L64.5311796,409.750048 C64.9973421,409.750048 65.3749276,409.372463 65.3749276,408.9063 L65.3749276,407.218804 C65.3749276,406.752642 64.9973421,406.375056 64.5311796,406.375056 L35.843748,406.375056 C35.3775855,406.375056 35,406.752642 35,407.218804 L35,408.9063 C35,409.372463 35.3775855,409.750048 35.843748,409.750048 L36.687496,409.750048 L36.687496,423.250016 C36.687496,424.181826 37.4431819,424.937512 38.374992,424.937512 L48.4999678,424.937512 L48.4999678,426.770027 L44.5285742,430.741421 C44.1989851,431.07101 44.1989851,431.605253 44.5285742,431.934842 L45.7213776,433.127646 C46.0509666,433.457235 46.5852099,433.457235 46.9147989,433.127646 L50.1874638,429.854981 L53.4601286,433.127646 C53.7897177,433.457235 54.323961,433.457235 54.65355,433.127646 Z M60.3124397,421.56252 L40.0624879,421.56252 L40.0624879,409.750048 L60.3124397,409.750048 L60.3124397,421.56252 Z",
    id: "\\uF685"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemonstration);
export default __webpack_public_path__ + "static/media/demonstration.2dc7f6b7aaa523e02a3d1261ddf7af6d.svg";
export { ForwardRef as ReactComponent };